module.exports = __webpack_public_path__ + "f435d7a015aa14d159fd5b3fbcda0234.png";